package org.hs_soft.runmynesto.domain.config

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onBlur
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocus
import com.varabyte.kobweb.compose.ui.modifiers.onMouseDown
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.onMouseUp
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.toModifier
import kotlinx.browser.document
import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.css.*
import org.w3c.dom.HTMLElement


fun Modifier.rippleEffect(
    isClickable:Boolean=true,
    onClick: (SyntheticMouseEvent) -> Unit
): Modifier = this.then(
    Modifier
        .attrsModifier {
        onClick { event ->
            if (isClickable){
                val target = event.currentTarget as? HTMLElement ?: return@onClick
                val rect = target.getBoundingClientRect()
                val ripple = document.createElement("div") as HTMLElement

                ripple.style.apply {
                    position = "absolute"
                    borderRadius = "inherit"
                    background = Theme.ActionDisabledBackground.rgb.toString()
                    width = "${rect.width}px"
                    height = "${rect.height}px"
                    left = "0"
                    top = "0"
                    transform = "scale(0)"
                    transition = "transform ${Constants.mediumTransition}, " +
                            "opacity ${Constants.mediumTransition}"
                    zIndex = "1"
                }

                target.style.position = "relative"
                target.style.overflowY = "hidden"
                target.style.overflowX = "hidden"

                target.appendChild(ripple)

                // Animate the ripple
                window.setTimeout({
                    ripple.style.transform = "scale(1)"
                    ripple.style.opacity = "0"
                }, 0)

                // Remove the ripple after animation
                window.setTimeout({
                    target.removeChild(ripple)
                }, Constants.expandingTimeOut)

                onClick(event)
            }

        }
    }
)


fun Modifier.blueGradientEffect(
    isClickable: Boolean = true,
    onClick: (SyntheticMouseEvent) -> Unit
): Modifier = this.then(
    Modifier
        .styleModifier {
            backgroundColor(Theme.PrimaryMain.rgb)
            position(Position.Relative)
            overflow(Overflow.Hidden)
            zIndex(1)
        }
        .attrsModifier {
            onClick { event ->
                if (isClickable) {
                    val target = event.currentTarget as? HTMLElement ?: return@onClick

                    val effectContainer = document.createElement("div") as HTMLElement
                    effectContainer.style.apply {
                        position = "absolute"
                        top = "0"
                        left = "0"
                        width = "100%"
                        height = "100%"
                        overflowY = "hidden"
                        overflowX = "hidden"
                        borderRadius = "inherit"
                        zIndex = "2"
                    }

                    val circle = document.createElement("div") as HTMLElement

                    val rect = target.getBoundingClientRect()
                    val maxDimension = rect.width
                    val scale = maxDimension / 100 * 2

                    circle.style.apply {
                        position = "absolute"
                        left = "50%"
                        top = "50%"
                        width = "100px"
                        height = "100px"
                        marginLeft = "-50px"
                        marginTop = "-50px"
                        borderRadius = "50%"
                        zIndex = "2"
                        backgroundColor = Theme.WhiteMain.hex
                        opacity = "0.12"
                        transform = "scale(0)"
                        transition = "transform ${Constants.fastExpandingTime}s " +
                                "ease-out, opacity ${Constants.fastExpandingTime}s ease-out"
                    }

                    effectContainer.appendChild(circle)
                    target.appendChild(effectContainer)

                    window.setTimeout({
                        circle.style.opacity = "0.6"
                        circle.style.transform = "scale(${scale})"

                        window.setTimeout({
                            circle.style.opacity = "0"

                            window.setTimeout({
                                try {
                                    target.removeChild(effectContainer)
                                } catch (e: Throwable) {
                                    console.error("Failed to remove effect container", e)
                                }
                            }, 500)
                        }, 400)
                    }, 0)

                    onClick(event)
                }
            }
        }
)

fun Modifier.overflowText():Modifier{
    return this.then(
        Modifier
            .whiteSpace(WhiteSpace.NoWrap)
            .overflow(Overflow.Hidden)
            .textOverflow(TextOverflow.Ellipsis)
            .styleModifier {
//                property("display", "block")
//                property("max-height", "1.2em")
//                property("line-height", "1.2em")
//                property("word-break", "break-all")
             }

    )
}

@Composable
fun Modifier.autoResponsiveness():Modifier{
    return this.then(
        Modifier
            .hideScrollBar()
            .overflow(Overflow.Visible)
            .display(DisplayStyle.Flex)
            .flexWrap(FlexWrap.Wrap)
    )
}

@Composable
fun Modifier.showContentInOnePage():Modifier{
    return this.then(
        VerticalScrollBehavior.toModifier()
            .overflow(Overflow.Auto)
            .styleModifier {
                flexGrow(1)
                overflowY("auto")
            }
            .height(0.px)
    )
}

fun Modifier.backgroundDialog():Modifier{
    return this.then(
        Modifier
            .fillMaxSize()
            .backgroundColor(Theme.ActionDisabledBackground.rgb)
            .zIndex(Constants.ZIndex.extraExtraLargeZIndex)
            .position(Position.Fixed)
            .styleModifier {
                property("top", "0")
                property("left", "0")
                property("right", "0")
                property("bottom", "0")
                property("width", "100vw")
                property("height", "100vh")
            }

    )

}

fun Modifier.scrollBar():Modifier{
   return this.then(
           Modifier.attrsModifier {
           style {
               property("scrollbar-width", "auto")
               property("scrollbar-color",
                   "${Theme.ActionDisabledBackground.rgb} transparent")
           }
       }
   )
}
fun Modifier.hideScrollBar():Modifier{
    return this.then(
        Modifier.attrsModifier {
            style {
                property("scrollbar-width", "none")
            }
        }
    )
}

@Composable
fun Modifier.circleHoverAroundItem(
    padding: CSSSizeValue<CSSUnit.px> =Dimen.semiSemiNormalPadding,
    showHover:Boolean=true,
    showMouseDownHover:Boolean=true,
    focusedColor:CSSColorValue=Theme.ActionFocused.rgb,
    hoveredColor:CSSColorValue=Theme.ActionHover.rgb,
    onClick:()->Unit,
    onMouseEnter:()->Unit={},
    onMouseLeave:()->Unit={},
):Modifier{

    val isHovered= remember { mutableStateOf(false) }
    val isFocused= remember { mutableStateOf(false) }

    return this.then(
        Modifier
            .padding(padding)
            .transitionBackground()
            .borderRadius(50.percent)
            .onMouseOver {
                onMouseEnter()
                isHovered.value = true
            }
            .onMouseLeave {
                onMouseEnter()
                isHovered.value = false
            }
            .onMouseDown {isFocused.value=true}
            .onMouseUp { isFocused.value=false }
            .backgroundColor(
                if(isFocused.value && showMouseDownHover) focusedColor
                else if (isHovered.value && showHover) hoveredColor
                else Theme.Transparent.rgb
            )
            .onClick {
                event: SyntheticMouseEvent -> event.stopPropagation()
                onClick()
            }
    )

}


fun Modifier.transitionBackground(): Modifier {
    return this.then(
        Modifier.transition(
            Transition.of(
                property = "background-color",
                duration = Constants.fastTransition
            )
        )
    )
}
fun Modifier.transitionColor(): Modifier {
    return this.then(
        Modifier.transition(
            Transition.of(
                property = "color",
                duration = Constants.fastTransition
            )
        )
    )
}

fun Modifier.generalDialogSetting(): Modifier {
    return this.then(
        Modifier
            .backgroundColor(Theme.White.rgb)
            .zIndex(Constants.ZIndex.largeZIndex)
            .boxShadow(
                color = Theme.ActionDisabledBackground.rgb,
                blurRadius = Dimen.normalBlurRadius,
                spreadRadius = Dimen.normalSpreadRadius,

            )
            .borderRadius(r= Dimen.semiLargeRadius)
            .onClick {
                event: SyntheticMouseEvent -> event.stopPropagation()
            },
    )
}


fun Modifier.borderSetting(): Modifier {
    return this.then(
        Modifier
            .padding(Dimen.largePadding)
            .borderRadius(Dimen.lowBorderRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    )
}

fun Modifier.transitionPageBackground(isVisible:Boolean):Modifier{
    return this.then(
        Modifier
            .attrsModifier {
                style {
                    property("transition",
                        "opacity ${Constants.fastTransition} ease-in-out")
                    property("opacity", if (isVisible) "1" else "0")
                }
            }
    )
}

fun Modifier.transitionBorder(): Modifier {
    return this.then(
        Modifier.transition(
            Transition.of(
                property = "border",
                duration = Constants.fastTransition,
            )
        )
    )
}

fun Modifier.transitionBorderWidth(): Modifier {
    return this.then(
        Modifier.transition(
            Transition.of(
                property = "border-width",
                duration = Constants.fastTransition,
            )
        )
    )
}

val hoverBackgroundStyle by ComponentStyle {
    base {
        Modifier.transition(
            Transition.of(
                property = "background",
                duration = Constants.fastTransition
            )
        )
    }
}



val VerticalScrollBehavior by ComponentStyle {
    base {
        Modifier
            .styleModifier {
                property("overflow-y", "auto")
                property("overflow-x", "hidden")
                property("scrollbar-width", "none")
                property("::-webkit-scrollbar", "width: 0px;")
                property("::-webkit-scrollbar-thumb", "background-color: darkgrey;")
                property("::-webkit-scrollbar-track", "background: lightgrey;")
            }

    }

}


val HorizontalScrollBehavior by ComponentStyle {
    base {
        Modifier
            .styleModifier {
                property("overflow-y", "hidden")
                property("overflow-x", "auto")
                property("scrollbar-width", "none")
                property("::-webkit-scrollbar", "width: 0px;")
                property("::-webkit-scrollbar-thumb", "background-color: darkgrey;")
                property("::-webkit-scrollbar-track", "background: lightgrey;")
            }

    }

}
const val gradientStyle = "linear-gradient(to right, red, orange, yellow, green, cyan, blue, violet)"
